import React, { useState, useEffect } from 'react'
import { scroller } from "react-scroll";
import { Link } from "react-scroll";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaWhatsapp } from "react-icons/fa";
import logo from "../../assets/images/new/personal image png.png"
import { navLinksdata } from '../../manager/project-data-manager/NavLinksData/NavLinksData';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../common/UI/LanguageSwitcher/LanguageSwitcher';
import { useLocation, useNavigate } from 'react-router-dom';


const Navbar = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);

  const navigate = useNavigate();


  // حل المشكلة الأولى: منع التمرير عند فتح القائمة
  useEffect(() => {
    if (showMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    // تنظيف التأثير عند إلغاء تركيب المكون
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showMenu]);

  const handleNavClick = (link) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: link } });
    } else {
      scroller.scrollTo(link, {
        duration: 500,
        delay: 0,
        smooth: true,
        offset: -70,
      });
    }
    setShowMenu(false);
  };

  return (
    <div className={`w-full h-24 sticky top-0 z-50 bg-bodyColor mx-auto flex justify-between items-center font-titleFont border-b-[1px] border-b-gray-600 ${i18n.language === 'ar' ? 'ar-dir' : 'en-dir'}`}>
      <div style={{ width: '80px', height: '80px' }}>
        <img
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            border: '1px solid black',
            objectFit: 'cover',
            objectPosition: 'top'
          }}
          src={logo}
          alt="logo"
        />
      </div>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '25px', flexDirection: 'row' }}>
          <ul className="hidden mdl:inline-flex items-center gap-6 lg:gap-10">
            {location.pathname !== '/' && navLinksdata.map(({ _id, titleKey, link }) => (
              <li
                className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
                key={_id}
                onClick={() => handleNavClick(link)}
              >
                {t(`navbar.${titleKey}`)}
              </li>
            ))}

            {location.pathname === '/' && navLinksdata.map(({ _id, titleKey, link }) => (
              <Link
                key={_id}
                to={link}
                spy={true}
                smooth={true}
                duration={500}
                offset={-70}
                activeClass="active"
                className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
              >
                {t(`navbar.${titleKey}`)}
              </Link>))}
          </ul>
          <span className="text-xl hidden mdl:inline-flex bg-black w-10 h-10 items-center justify-center rounded-full text-designColor cursor-pointer">
            <LanguageSwitcher />
          </span>
        </div>
        <span
          onClick={() => setShowMenu(!showMenu)}
          className="text-xl mdl:hidden bg-black w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer"
        >
          {showMenu ? <MdClose /> : <FiMenu />}
        </span>
        <span className="text-xl mdl:hidden bg-black w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer m-1">
          <LanguageSwitcher />
        </span>
        {showMenu && (
          <div className="w-full h-screen fixed top-24 left-0 bg-[#212428] p-4 scrollbar-hide">
            <div className="flex flex-col gap-8 py-2">
              <ul className="flex flex-col gap-4">
                {location.pathname !== '/' && navLinksdata.map((item) => (
                  <li
                    key={item._id}
                    className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
                    onClick={() => handleNavClick(item.link)}
                  >
                    {t(`navbar.${item.titleKey}`)}
                  </li>
                ))}
                {location.pathname === '/' && navLinksdata.map((item) => (
                  <li
                    key={item._id}
                    className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
                  >
                    <Link
                      onClick={() => setShowMenu(false)}
                      activeClass="active"
                      to={item.link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                    >
                      {t(`navbar.${item.titleKey}`)}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="flex flex-col gap-4">
                <h2 className="text-base uppercase font-titleFont mb-4">
                  {t("banner.findMe")}
                </h2>
                <div className="flex gap-4">
                  <a
                    href="https://www.facebook.com/moayad.ismail.524/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="bannerIcon">
                      <FaFacebookF />
                    </span>
                  </a>

                  <a
                    href="https://www.instagram.com/moayad.ismail.99/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="bannerIcon">
                      <FaInstagram />
                    </span>
                  </a>
                  <a href="https://wa.me/968577071" target="_blank" rel="noopener noreferrer">
                    <span className="bannerIcon ">
                      <FaWhatsapp />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar;